import constants from 'app/constants'
import { LOCAL_STORAGE } from 'app/localStorageManager'
import { ERROR_CODE } from 'app/util/errorCodes'
import fetchJSONData from 'app/util/fetchJSONData'
import { API_ERROR_RESPONSE_MESSAGE } from './constants'

const submitClaimWithShippingJWT = async formData => {
  const token = localStorage.getItem(LOCAL_STORAGE.userTokenCache)

  if (!token) {
    throw new Error('Failed to get JWT')
  }

  const { data, success } = await fetchJSONData(
    `${constants.API_URL}/utility/claim/with_shipping`,
    {
      method: 'POST',
      body: JSON.stringify({
        ...formData,
        network: constants.NETWORK
      }),
      headers: {
        'company-id': constants.API_ID,
        'Content-Type': 'application/json',
        'x-access-token': token
      }
    },
    false
  )

  if (!success) {
    throw new Error('Claim error')
  }

  if (data?.token) {
    // Has token, add it to local storage
    localStorage.setItem(LOCAL_STORAGE.userTokenCache, data.token)
  }

  return data
}

/**
 * Submit a redeemable reward claim with shipping (physical products)
 *
 * @param {object} formData - the precompiled form data
 * @returns {Promise} resolves on completion
 */
const submitClaimWithShipping = async formData => {
  let res

  try {
    res = await submitClaimWithShippingJWT(formData)
  } catch (e) {}

  if (!res) {
    return {
      success: false,
      message: ERROR_CODE.UNKNOWN
    }
  }

  if (res?.message === 'claimed') {
    return {
      success: true,
      ...res
    }
  }

  return {
    success: false,
    message: API_ERROR_RESPONSE_MESSAGE[res?.message] || ERROR_CODE.UNKNOWN
  }
}

// Export
export default submitClaimWithShipping
